import { toTicks } from '../engine/ticks.js';
import { materialize } from '../parse/resolve.js';
import { formatWhen } from './format.js';
const EMPTY = { precision: null, qualifier: null, reason: null, earliest: null, latest: null };
/**
 * A point (and a `now` phrase once a NOW resolves it) carries `toTicks`'s status and bounds;
 * relative and session phrases are `pending` (their bounds come from the solver and the session);
 * `undated` is `undated`; a parse error or an unset NOW is `invalid` with its reason.
 */
export function preview(parsed, calendar, options) {
    if (typeof parsed !== 'object' || parsed === null) {
        return {
            kind: 'invalid',
            canonical: null,
            ...EMPTY,
            status: 'invalid',
            reason: 'unexpected_text',
        };
    }
    const canonical = formatWhen(parsed, calendar);
    switch (parsed.kind) {
        case 'invalid':
            return {
                kind: 'invalid',
                canonical: null,
                ...EMPTY,
                status: 'invalid',
                reason: parsed.reason,
            };
        case 'undated':
            return { kind: 'undated', canonical, ...EMPTY, status: 'undated' };
        case 'session':
        case 'relative':
            return { kind: parsed.kind, canonical, ...EMPTY, status: 'pending' };
        case 'point':
        case 'now': {
            const point = parsed.kind === 'now' ? materialize(parsed, calendar, options) : parsed;
            const shape = { kind: parsed.kind, canonical };
            if (point.kind === 'invalid') {
                return {
                    ...shape,
                    ...EMPTY,
                    precision: 'minute',
                    qualifier: 'exact',
                    status: 'invalid',
                    reason: point.reason,
                };
            }
            const p = point;
            const ticks = toTicks(calendar, p);
            const base = { ...shape, precision: p.precision, qualifier: p.qualifier };
            switch (ticks.status) {
                case 'ok':
                    return { ...base, status: 'ok', reason: null, earliest: ticks.lo, latest: ticks.hi };
                case 'open_lo':
                    return { ...base, status: 'open_lo', reason: null, earliest: null, latest: ticks.hi };
                case 'open_hi':
                    return { ...base, status: 'open_hi', reason: null, earliest: ticks.lo, latest: null };
                default:
                    return { ...base, status: 'invalid', reason: ticks.reason, earliest: null, latest: null };
            }
        }
        default:
            return {
                kind: 'invalid',
                canonical: null,
                ...EMPTY,
                status: 'invalid',
                reason: 'unexpected_text',
            };
    }
}
//# sourceMappingURL=preview.js.map